import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/app/auth-context';
import { PageLoading } from '@/components/feedback/page-loading';
import { routes } from '@/lib/routes';

export function IntakeLanguageEntry({ language }: { language: 'en' | 'ar' }) {
  const { i18n } = useTranslation();
  const { user, isLoading } = useAuth();
  const [languageReady, setLanguageReady] = useState(i18n.resolvedLanguage === language);

  useEffect(() => {
    let active = true;
    void i18n.changeLanguage(language).then(() => {
      if (active) setLanguageReady(true);
    });
    return () => {
      active = false;
    };
  }, [i18n, language]);

  if (isLoading || !languageReady) return <PageLoading />;
  const intakeReturn = encodeURIComponent(routes.intake);
  if (!user) {
    return <Navigate to={`${routes.register}?returnTo=${intakeReturn}`} replace />;
  }
  if (!user.onboardingCompleted) {
    return <Navigate to={`${routes.onboarding}?returnTo=${intakeReturn}`} replace />;
  }
  return <Navigate to={routes.intake} replace />;
}

export default IntakeLanguageEntry;
